import { ascending } from '../../../../utils/array-utils';
import { SubscribedProduct } from '../../me/products/types';
import { Provider } from '../../me/providers/types';
import { Recording } from '../../recordings/types/recording';
import { EpisodeAsset } from '../types/asset';
import { EpisodeTitle, Title } from '../types/title';
import { createSources } from './sources-utils';
import { BookmarkReference } from '../../me/bookmarks/types';

export function createEpisodes(
  episodes: EpisodeTitle[],
  providers: Provider[],
  recordings: Recording[],
  products: SubscribedProduct[],
  bookmarks: BookmarkReference[],
): EpisodeAsset[] {
  try {
    const sortFn = ascending((x: EpisodeTitle) => [x.season.sequenceNumber, x.episode.sequenceNumber]);
    const sortedEpisodes = [...episodes].sort(sortFn);

    return sortedEpisodes.map((ep) => {
      const sources = createSources(ep.playbackOptions, providers, recordings, products, bookmarks);
      return { ...ep, sources };
    });
  } catch (error) {
    return episodes.map((ep) => {
      const sources = createSources(ep.playbackOptions, providers, recordings, products, bookmarks);
      return { ...ep, sources };
    });
  }
}

export function getProviders(title: Title, providers: Provider[]) {
  const providersArr: Provider[] = [];

  for (const option of title.playbackOptions) {
    const provider = providers.find((p) => p.id === option.providerIdentifier);
    if (provider) {
      providersArr.push(provider);
    }
  }

  return providersArr;
}
